// @flow
import AssessmentModel from "src/models/AssessmentAnswerModel";
import { entityReducer } from "src/utils/reducerUtils";

export const assessmentAnswers = entityReducer({
  name: "assessmentAnswers",
  Model: AssessmentModel
});
